























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class ReusableCard extends Vue {
  @Prop({ default: "12" }) cols!: string;
  @Prop({ default: "12" }) md!: string;
  @Prop({ default: "$siteGreen" }) backgroundColor!: string;
  @Prop({ default: "#FFFFFF" }) headingColor!: string;
  @Prop({ default: "Card" }) heading!: string;
}
